// 2026-10-26 广告/分析同意（EU 专用）
const VERSION = '2026-10-26';
const COOKIE = 'sr_consent';
const API = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');

const COPY = {
    en: {
        title: 'We value your privacy',
        body: 'We use cookies and identifiers for analytics and advertising. You can accept all or reject non-essential.',
        accept: 'Accept all',
        reject: 'Reject non-essential'
    },
    de: {
        title: 'Wir respektieren Ihre Privatsphäre',
        body: 'Wir verwenden Cookies und Kennungen für Analyse und Werbung. Sie können alle akzeptieren oder nicht notwendige ablehnen.',
        accept: 'Alle akzeptieren',
        reject: 'Nicht notwendige ablehnen'
    },
    fr: {
        title: 'Nous respectons votre vie privée',
        body: 'Nous utilisons des cookies et identifiants pour l’analyse et la publicité. Vous pouvez tout accepter ou refuser les cookies non essentiels.',
        accept: 'Tout accepter',
        reject: 'Refuser les non essentiels'
    },
    es: {
        title: 'Respetamos tu privacidad',
        body: 'Usamos cookies e identificadores para analítica y publicidad. Puedes aceptar todo o rechazar los no esenciales.',
        accept: 'Aceptar todo',
        reject: 'Rechazar no esenciales'
    },
    pt: {
        title: 'Respeitamos a sua privacidade',
        body: 'Usamos cookies e identificadores para análise e publicidade. Pode aceitar tudo ou rejeitar os não essenciais.',
        accept: 'Aceitar tudo',
        reject: 'Rejeitar não essenciais'
    },
    it: {
        title: 'Rispettiamo la tua privacy',
        body: 'Utilizziamo cookie e identificatori per analisi e pubblicità. Puoi accettare tutto o rifiutare i non essenziali.',
        accept: 'Accetta tutto',
        reject: 'Rifiuta i non essenziali'
    },
    nl: {
        title: 'Wij respecteren uw privacy',
        body: 'Wij gebruiken cookies en identificatoren voor analyse en advertenties. U kunt alles accepteren of niet-essentiële weigeren.',
        accept: 'Alles accepteren',
        reject: 'Niet-essentiële weigeren'
    },
    pl: {
        title: 'Szanujemy Twoją prywatność',
        body: 'Używamy plików cookie i identyfikatorów do analityki i reklam. Możesz zaakceptować wszystko lub odrzucić niezbędne.',
        accept: 'Akceptuj wszystko',
        reject: 'Odrzuć niezbędne'
    }
};

function copy() {
    const lang = (navigator.language || 'en').toLowerCase().split('-')[0];
    return COPY[lang] || COPY.en;
}

function cookieDomain() {
    const host = location.hostname;
    if (host === 'skinroll.net' || host.endsWith('.skinroll.net')) return '; domain=.skinroll.net';
    if (host === 'fateskins.net' || host.endsWith('.fateskins.net')) return '; domain=.fateskins.net';
    return '';
}

export function getConsent() {
    if (typeof document === 'undefined') return null;
    const m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!m) return null;
    try {
        const data = JSON.parse(decodeURIComponent(m[1]));
        if (!data || typeof data.ads === 'undefined') return null;
        return { ads: Number(data.ads) === 1 ? 1 : 0, analytics: Number(data.analytics) === 1 ? 1 : 0 };
    } catch (e) {
        return null;
    }
}

function setConsent(choice) {
    const value = encodeURIComponent(JSON.stringify({
        v: VERSION,
        ads: choice.ads ? 1 : 0,
        analytics: choice.analytics ? 1 : 0,
        ts: Date.now()
    }));
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE + '=' + value + '; path=/; max-age=15552000; SameSite=Lax' + cookieDomain() + secure;
}

function saveServer(choice) {
    try {
        const token = localStorage.getItem('token') || localStorage.getItem('access_token') || localStorage.getItem('Authorization');
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers.Authorization = 'Bearer ' + token.replace(/^Bearer\s+/i, '');
        fetch(API + '/consent/save', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ ads: choice.ads ? 1 : 0, analytics: choice.analytics ? 1 : 0 })
        }).catch(function () {});
    } catch (e) {}
}

function showBanner(choiceCallback, deniedCallback) {
    const mount = function () {
        if (document.getElementById('sr-consent-banner')) return;
        const c = copy();
        const wrap = document.createElement('div');
        wrap.id = 'sr-consent-banner';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-live', 'polite');
        wrap.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#111318;color:#fff;border-top:1px solid #2a2e39;box-shadow:0 -8px 30px rgba(0,0,0,.35);font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;padding:16px 18px;';
        wrap.innerHTML =
            '<div style="max-width:1180px;margin:0 auto;display:flex;gap:14px;align-items:center;flex-wrap:wrap;">' +
            '<div style="flex:1;min-width:260px;">' +
            '<div data-sr="title" style="font-size:15px;font-weight:600;margin-bottom:4px;"></div>' +
            '<div data-sr="body" style="color:#b9c0cc;"></div>' +
            '</div>' +
            '<button type="button" data-sr="reject" style="cursor:pointer;border:1px solid #3a4050;background:transparent;color:#fff;border-radius:6px;padding:10px 14px;font-size:14px;"></button>' +
            '<button type="button" data-sr="accept" style="cursor:pointer;border:0;background:#f0b90b;color:#111;border-radius:6px;padding:10px 16px;font-size:14px;font-weight:600;"></button>' +
            '</div>';
        wrap.querySelector('[data-sr="title"]').textContent = c.title;
        wrap.querySelector('[data-sr="body"]').textContent = c.body;
        wrap.querySelector('[data-sr="reject"]').textContent = c.reject;
        wrap.querySelector('[data-sr="accept"]').textContent = c.accept;

        const close = function (choice) {
            setConsent(choice);
            saveServer(choice);
            const el = document.getElementById('sr-consent-banner');
            if (el) el.parentNode.removeChild(el);
            choiceCallback(choice);
        };
        wrap.querySelector('[data-sr="accept"]').addEventListener('click', function () {
            close({ ads: 1, analytics: 1 });
        });
        wrap.querySelector('[data-sr="reject"]').addEventListener('click', function () {
            close({ ads: 0, analytics: 0 });
        });
        document.body.appendChild(wrap);
        deniedCallback();
    };
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount, { once: true });
}

export async function initConsent(onChange) {
    if (typeof window === 'undefined' || window.__srConsentInit) return;
    window.__srConsentInit = true;

    let required = false;
    try {
        let configUrl = API + '/consent/config';
        // 仅测试服：?consent_country=DE 强制国家，便于非 EU 出口验证横幅
        if (typeof location !== 'undefined' && /fateskins\.net$/i.test(location.hostname)) {
            const m = location.search.match(/[?&]consent_country=([A-Za-z]{2})(?:&|$)/);
            if (m) configUrl += '?country=' + m[1].toUpperCase();
        }
        const resp = await fetch(configUrl, { credentials: 'omit' });
        const json = await resp.json();
        if (json && json.data) required = !!json.data.required;
    } catch (e) {}

    const apply = function (choice) {
        if (typeof window !== 'undefined') window.__srAdsGranted = !!choice.ads;
        onChange(choice);
    };
    const stored = getConsent();
    if (stored) {
        apply(stored);
        return;
    }
    if (!required) {
        apply({ ads: 1, analytics: 1 });
        return;
    }
    showBanner(function (choice) {
        apply(choice);
    }, function () {
        apply({ ads: 0, analytics: 0 });
    });
}
